// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services_page_wrapper .container {
   display: flex;
   justify-content: left;
   align-items: left;
   flex-direction: column;
   padding-top: 30px;
   padding-bottom: 50px;
   max-width: 100%;
}


.inner_nav_list {
    grid-column-gap: 22px;
    grid-row-gap: 22px;
    align-items: center;
    margin-bottom: 0;
    padding-left: 0;
    list-style-type: none;
    display: flex;
    flex-direction: row;
    max-width: 100%;
}


.active {
    color: #0e0f10;
    background-color: #f0f2f6;
    border-bottom-style: none;
    padding: 2px 13px;
    display: block;
    border-radius: 5px;
}

.title_content {
    margin-top: 1.5em;
    margin-bottom: .5em;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.3em;
}

.blockquote {
    text-align: left;
    background-color: #f0f2f6;
    border-left-style: none;
    border-radius: 4px;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    margin-left: 0;
    padding: 1.25rem 1.5rem;
    font-size: 16px; 
}

.services_page_grid {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    flex-direction: row;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: flex;
    max-width: 100%;
}

.footer_content {
    margin-top: 35px;
    margin-bottom: 35px;
}


.aside_nav {
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: left;
    border: 1px solid rgba(128, 128, 128, 0.459);
    border-radius: 10px;
    padding: 20px;
    max-width: 100%;
}

ul {
    padding: 0;
    line-height: 30px;
}
.services_page_content {
    line-height: 30px;
    max-width: 60%;
}


@media (max-width: 980px) {
    .services_page_wrapper .container {
        max-width: 100%;
    }
    .services_page_header {
       font-size: 3vw;
    }
    .blockquote {
        max-width: 100%;
        line-height: calc(25px + 1.5vw);
        font-size: calc(4px + 1vw);
    }
    .services_page_content{
        max-width: 100%;
        line-height: calc(25px + 1.5vw);
        padding-right: 0px;
        font-size: calc(4px + 1vw);
    }
    ul {
        max-width: 100%;
        line-height: calc(25px + 1.5vw);
        font-size: calc(4px + 1vw);
    }
    .inner_nav_list {
        line-height: 45px;
        font-size: calc(16px + 1vw);
    }
    .aside_nav_item {
        line-height: 45px;
        font-size: calc(16px + 1vw);
    }
    .aside_title {
        font-size: calc(16px + 1vw);
    }
    .services_page_grid {
        flex-direction: column;
    }
}


.ul {
    padding-left: 40px;
    list-style-type: "✔ ";
}

.p {
    margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/servicesPage/ui/ServicesPage.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,qBAAqB;GACrB,iBAAiB;GACjB,sBAAsB;GACtB,iBAAiB;GACjB,oBAAoB;GACpB,eAAe;AAClB;;;AAGA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;;AAGA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI;QACI,eAAe;IACnB;IACA;OACG,cAAc;IACjB;IACA;QACI,eAAe;QACf,+BAA+B;QAC/B,0BAA0B;IAC9B;IACA;QACI,eAAe;QACf,+BAA+B;QAC/B,kBAAkB;QAClB,0BAA0B;IAC9B;IACA;QACI,eAAe;QACf,+BAA+B;QAC/B,0BAA0B;IAC9B;IACA;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;IACA;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,sBAAsB;IAC1B;AACJ;;;AAGA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".services_page_wrapper .container {\n   display: flex;\n   justify-content: left;\n   align-items: left;\n   flex-direction: column;\n   padding-top: 30px;\n   padding-bottom: 50px;\n   max-width: 100%;\n}\n\n\n.inner_nav_list {\n    grid-column-gap: 22px;\n    grid-row-gap: 22px;\n    align-items: center;\n    margin-bottom: 0;\n    padding-left: 0;\n    list-style-type: none;\n    display: flex;\n    flex-direction: row;\n    max-width: 100%;\n}\n\n\n.active {\n    color: #0e0f10;\n    background-color: #f0f2f6;\n    border-bottom-style: none;\n    padding: 2px 13px;\n    display: block;\n    border-radius: 5px;\n}\n\n.title_content {\n    margin-top: 1.5em;\n    margin-bottom: .5em;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 1.3em;\n}\n\n.blockquote {\n    text-align: left;\n    background-color: #f0f2f6;\n    border-left-style: none;\n    border-radius: 4px;\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n    margin-left: 0;\n    padding: 1.25rem 1.5rem;\n    font-size: 16px; \n}\n\n.services_page_grid {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    flex-direction: row;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: flex;\n    max-width: 100%;\n}\n\n.footer_content {\n    margin-top: 35px;\n    margin-bottom: 35px;\n}\n\n\n.aside_nav {\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    justify-content: left;\n    border: 1px solid rgba(128, 128, 128, 0.459);\n    border-radius: 10px;\n    padding: 20px;\n    max-width: 100%;\n}\n\nul {\n    padding: 0;\n    line-height: 30px;\n}\n.services_page_content {\n    line-height: 30px;\n    max-width: 60%;\n}\n\n\n@media (max-width: 980px) {\n    .services_page_wrapper .container {\n        max-width: 100%;\n    }\n    .services_page_header {\n       font-size: 3vw;\n    }\n    .blockquote {\n        max-width: 100%;\n        line-height: calc(25px + 1.5vw);\n        font-size: calc(4px + 1vw);\n    }\n    .services_page_content{\n        max-width: 100%;\n        line-height: calc(25px + 1.5vw);\n        padding-right: 0px;\n        font-size: calc(4px + 1vw);\n    }\n    ul {\n        max-width: 100%;\n        line-height: calc(25px + 1.5vw);\n        font-size: calc(4px + 1vw);\n    }\n    .inner_nav_list {\n        line-height: 45px;\n        font-size: calc(16px + 1vw);\n    }\n    .aside_nav_item {\n        line-height: 45px;\n        font-size: calc(16px + 1vw);\n    }\n    .aside_title {\n        font-size: calc(16px + 1vw);\n    }\n    .services_page_grid {\n        flex-direction: column;\n    }\n}\n\n\n.ul {\n    padding-left: 40px;\n    list-style-type: \"✔ \";\n}\n\n.p {\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
